import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'afoone-wxrl-form-header',
  templateUrl: './wxrl-form-header.component.html',
  styleUrls: ['./wxrl-form-header.component.css']
})
export class WxrlFormHeaderComponent implements OnInit {
  @Input() title: string = '';
  @Input() activeTab: 'Cabecera' | 'Condiciones' | 'Acciones' | 'Disparadores' | 'Fórmula' = 'Condiciones';

  tabs: Array<{ id: string; label: string; icon: string }> = [];

  constructor(private _translate: TranslateService) {}

  ngOnInit(): void {
    this.tabs = [
      { id: 'Cabecera', label: this._translate.instant('WXRL.FORM_HEADER.CABECERA'), icon: 'pi pi-home' },
      { id: 'Condiciones', label: this._translate.instant('WXRL.FORM_HEADER.CONDICIONES'), icon: 'pi pi-list' },
      { id: 'Acciones', label: this._translate.instant('WXRL.FORM_HEADER.ACCIONES'), icon: 'pi pi-cog' },
      { id: 'Disparadores', label: this._translate.instant('WXRL.FORM_HEADER.DISPARADORES'), icon: 'pi pi-bolt' }
    ];
  }

  isActiveTab(tabId: string): boolean {
    return this.activeTab === tabId;
  }
}

